export default "<adn-creative-set-list list=\"list\"></adn-creative-set-list>\n";